import FoodApp from "@/features/food-overview";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/food-app/")({
  component: FoodApp,
});
